<div class="modal-dialog modal-lg">
	<div class="modal-content">
		<div class="modal-header">
			<h4 class="fs-4 modal-title pull-left border-0 text-center">
				Réordonner la liste
			</h4>
			<button
				type="button"
				class="btn-close close pull-right"
				aria-label="Close"
				(click)="closeModal()"
			>
				<span aria-hidden="true" class="visually-hidden">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<p class="text-center fs-5">
				Cliquez sur les flèches pour réordonner votre tournée, ou cliquez et
				faite glisser une visite jusqu'à l'emplacement voulu.
			</p>
			<ul class="list-group">
				<li
					role="button"
					class="drag-wrapper list-group-item pb-3 pt-3"
					*ngFor="let mission of missionListCopy; let index = index"
					[ngClass]="
						index % 2 === 0 ? 'list-group-item-dark' : 'list-group-item-light'
					"
					[draggable]="true"
					(dragstart)="onDragStart(index)"
					(dragenter)="onDragEnter(index)"
					(dragend)="onDragEnd()"
				>
					<div class="row d-flex align-items-center">
						<div class="col-10">
							<span class="row">
								<span class="col">
									{{ mission.missionRequest.beneficiaire.firstName }}</span
								>
								<span class="col">
									{{ mission.missionRequest.beneficiaire.lastName }}</span
								>
								<span class="col">
									{{ mission.plannedStart | minutesToTime }}</span
								>
								<span class="col">
									{{ mission.plannedEnd | minutesToTime }}</span
								>
							</span>
						</div>
						<span class="col-2 fs-3 text-end">
							<a (click)="changeIndexOfMissionFromRoute(-1, index)"
								><i
									class="bi bi-caret-up-fill theme-main-color pe-3"
									aria-hidden="true"
								></i
							></a>
							<a (click)="changeIndexOfMissionFromRoute(1, index)"
								><i
									class="bi bi-caret-down-fill theme-main-color"
									aria-hidden="true"
								></i
							></a>
						</span>
					</div>
				</li>
			</ul>
		</div>
		<div class="modal-footer d-flex justify-content-between">
			<button class="btn theme-red-button" (click)="closeModal()">
				Annuler
			</button>
			<button
				class="btn theme-green-button"
				(click)="validateChange()"
				[disabled]="isBtnValidateClicked"
			>
				Valider
			</button>
		</div>
	</div>
</div>
